<!-- Popup stepper -->
<aw-wizard class="wizard" [navBarDirection]="'right-to-left'" #wizard>
    <!-- Customer step -->
    <aw-wizard-step class="wizard__step" awOptionalStep>
        <div class="wizard__header">
            <h3 class="header__title">{{ eventTitle }}</h3>

            <div class="header__details">{{ appDataTemp?.start | date : "EEE, dd/MM '|' HH:mm" }}</div>
        </div>

        <div class="wizard__body">
            <app-create-app-customer
                [appDataTemp]="appDataTemp"
                (eventTitleChange)="eventTitle = $event"
                [config]="config"
                (onChangeCustomer)="onChangeCustomer($event)"
            ></app-create-app-customer>
        </div>

        <!-- Customer footer -->
        <div class="wizard__footer">
            <button
                class="absence-button button button_with-icon button_size_small button_theme_main-line"
                [disabled]="isEditingEvent"
                (click)="absenceInitialize()"
                [awGoToStep]="{ stepIndex: 3 }"
            >
                <i class="fa-regular fa-mug-hot"></i>
                זמן אישי
            </button>
            <span class="footer__text">לא רוצים לקבוע תור אלא היעדרות, הפסקה או חופשה?</span>
        </div>
    </aw-wizard-step>

    <!-- Service step -->
    <aw-wizard-step class="wizard__step" awOptionalStep>
        <div class="wizard__header">
            <h3 class="header__title">{{ eventTitle }}</h3>

            <div class="header__details">{{ appDataTemp.customerapp?.fl }} | {{ appDataTemp?.start | date : "EEE, dd/MM '|' HH:mm" }}</div>
        </div>

        <div class="wizard__body">
            <app-create-app-service
                [appDataTemp]="appDataTemp"
                [isEditingEvent]="isEditingEvent"
                (eventTitleChange)="eventTitle = $event"
                (onServiceToggle)="onServiceToggle($event)"
            ></app-create-app-service>
        </div>

        <!-- Service footer -->
        <div class="wizard__footer">
            <button class="button button_with-icon button_size_small button_theme_main" awNextStep (click)="summaryInitialize()">
                סיכום
                <i class="fa-regular fa-chevron-left"></i>
            </button>

            <button class="button button_with-icon button_size_small button_theme_gray-line" (click)="leaveServices()">
                <i class="fa-regular fa-chevron-right"></i>
                בחירת לקוח
            </button>
        </div>
    </aw-wizard-step>

    <!-- Summary step -->
    <aw-wizard-step class="wizard__step wizard__step_summary" [ngClass]="{ wizard__step_error: isErrorVisible }" awOptionalStep>
        <div class="wizard__header">
            <div class="header__error">
                <i class="error__icon fa-solid fa-triangle-exclamation"></i>
                <span>
                    <span class="error__text_bold">שימו לב!</span>לא סיימתם לערוך את שעת ההתחלה/סיום. לחצו על כפתור אישור או ביטול מתחת לגלגלת השעות
                </span>
            </div>

            <h3 class="header__title">{{ eventTitle }}</h3>
        </div>

        <div class="wizard__body">
            <app-create-app-summary
                [appDataTemp]="appDataTemp"
                (eventTitleChange)="eventTitle = $event"
                [config]="config"
                [configDiary]="configDiary"
                [resources]="resources"
                [holidayName]="holidayName"
                [invalid]="invalid"
                [isEditingEvent]="isEditingEvent"
                [isAppointorErrorVisible]="isAppointorErrorVisible"
                (isEditHoursChange)="isEditHoursChange($event)"
            ></app-create-app-summary>
        </div>

        <!-- Summary footer -->
        <div class="wizard__footer">
            <button
                class="button button_with-icon button_size_small button_theme_main"
                [disabled]="isErrorVisible || (isAppointorErrorVisible && !appDataTemp.appointorId)"
                (click)="finishFunction()"
            >
                שמירה
                <i class="fa-regular fa-chevron-left"></i>
            </button>

            <button class="button button_with-icon button_size_small button_theme_gray-line" awPreviousStep (click)="leaveSummary()">
                <i class="fa-regular fa-chevron-right"></i>
                שינוי טיפולים
            </button>
        </div>
    </aw-wizard-step>

    <!-- Absence step -->
    <aw-wizard-step class="wizard__step wizard__step_absence" [ngClass]="{ wizard__step_error: isErrorVisible }" awOptionalStep>
        <div class="wizard__header">
            <div class="header__error">
                <i class="error__icon fa-solid fa-triangle-exclamation"></i>
                <span><span class="error__text_bold">שימו לב!</span> לא סיימתם לערוך את שעת ההתחלה/הסיום, ולכן לא ניתן עדיין לשמור את התור</span>
            </div>

            <h3 class="header__title">{{ eventTitle }}</h3>
        </div>

        <div class="wizard__body">
            <app-create-app-absence
                [appDataTemp]="appDataTemp"
                (eventTitleChange)="eventTitle = $event"
                [config]="config"
                [configDiary]="configDiary"
                [resources]="resources"
                [holidayName]="holidayName"
                [invalid]="invalid"
                [isEditingEvent]="isEditingEvent"
                (isEditHoursChange)="isEditHoursChange($event)"
            ></app-create-app-absence>
        </div>

        <!-- Absence footer -->
        <div class="wizard__footer wizard__footer_absence">
            <button class="button button_size_small button_theme_main" [disabled]="isErrorVisible" (click)="finishFunction()">שמירה</button>
        </div>
    </aw-wizard-step>
</aw-wizard>
